import { render, staticRenderFns } from "./chemLaw.vue?vue&type=template&id=6875ed32"
import script from "./chemLaw.vue?vue&type=script&lang=js"
export * from "./chemLaw.vue?vue&type=script&lang=js"
import style0 from "./chemLaw.vue?vue&type=style&index=0&id=6875ed32&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6875ed32')) {
      api.createRecord('6875ed32', component.options)
    } else {
      api.reload('6875ed32', component.options)
    }
    module.hot.accept("./chemLaw.vue?vue&type=template&id=6875ed32", function () {
      api.rerender('6875ed32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemLaw.vue"
export default component.exports